"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PEPGuideConfigAnswer = _interopRequireDefault(require("./PEPGuideConfigAnswer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PEPGuideConfigQuestion =
/**
 *
 * @param {Object} config
 * @param {string} config.title The title of the question
 * @param {string} config.text The text for the question
 * @param {string} config.helpText The explanatory help text for the question
 * @param {string} config.Image specific image
 * @param {Array.<Object>} config.answers The list of answers for the question
 */
function PEPGuideConfigQuestion(config) {
  _classCallCheck(this, PEPGuideConfigQuestion);

  /**
   * The title of the questio
   * @type {string}
   */
  this.title = config.Title || config.title || '';
  /**
   * The text for the question
   * @type {string}
   */

  this.text = config.Text || config.text || '';
  /**
   * The explanatory help text for the question
   * @type {string}
   */

  this.helpText = config.HelpText || config.helpText || '';
  /**
   * The explanatory help text for the question
   * @type {string}
   */

  this.image = config.Image || '';
  /**
   * The list of answers for the question
   * @type {Array.<PEPGuideConfigAnswer>}
   */

  this.answers = function (answersData) {
    var answers = [];

    if (answersData && Array.isArray(answersData)) {
      answersData.forEach(function (answerData) {
        answers.push(new _PEPGuideConfigAnswer["default"](answerData));
      });
    }

    return answers;
  }(config.Answers || config.answers);
};

var _default = PEPGuideConfigQuestion;
exports["default"] = _default;